import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import NotificationComponent from './notification-component';
import MessagingContainerComponent from './messaging-container-component';

const mapStateToProps = state => ({
  user: state.Dashboard.user
});

class InboxComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { user, isMobile } = this.props;
    if (!user) return (<div className="container text-center"><h4>Loading...</h4></div>)
    return (<div className="container dashboard-container">
      <div className="row">
        <div className="col">
          {!isMobile && (<h2>Inbox</h2>)}
          <hr />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <NotificationComponent />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h2>Messages</h2>
          <hr />
        </div>
      </div>
      <MessagingContainerComponent />
    </div>);
  }
}

export default withRouter(connect(mapStateToProps)(InboxComponent));
